import ConfigSectorsTypes from "./types";
import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import { REHYDRATE } from "redux-persist";

const ConfigSectorsReducer = (state, action) => {
  const initialState = {
    areas: {
      items: [],
    },
    sectors: {
      items: [],
      data: {},
    },
  };

  if (!state) {
    state = initialState;
  }

  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
      };
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case ConfigSectorsTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: action.value,
      };
    case ConfigSectorsTypes.SET_AREAS_LOADING:
      return {
        ...state,
        areas: {
          ...state.areas,
          loading: action.value,
        },
      };
    case ConfigSectorsTypes.SET_AREAS:
      return {
        ...state,
        areas: {
          ...state.areas,
          loading: false,
          items: action.data,
        },
      };
    case ConfigSectorsTypes.SET_AREA_SELECTED:
      return {
        ...state,
        areas: {
          ...state.areas,
          selected: action.value,
        },
      };
    case ConfigSectorsTypes.SET_SECTORS_LOADING:
      return {
        ...state,
        sectors: {
          ...state.sectors,
          loading: action.value,
        },
      };
    case ConfigSectorsTypes.SET_SECTORS:
      return {
        ...state,
        sectors: {
          ...state.sectors,
          items: action.data,
        },
      };
    case ConfigSectorsTypes.SET_SECTORS_DATA:
      return {
        ...state,
        sectors: {
          ...state.sectors,
          data: action.data,
        },
      };
    default:
      return state;
  }
};

export default ConfigSectorsReducer;
